import type { ReactNode } from "react";

interface Fact {
  label: string;
  value: ReactNode;
}

/**
 * A responsive label/value grid — the layout every block on the user detail
 * page uses for its "here are the raw facts" section. One component, and no
 * column knob, so the blocks cannot drift apart visually as they are edited.
 */
export default function FactGrid({ facts }: { facts: Fact[] }) {
  return (
    <dl className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {facts.map((fact) => (
        <div key={fact.label}>
          <dt className="text-sm text-muted-foreground">{fact.label}</dt>
          <dd className="break-words font-medium">{fact.value}</dd>
        </div>
      ))}
    </dl>
  );
}
